import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import ButtonInc from '../../../../../shared-ui/ButtonInc';
import SkeletonWrapper from '../../../../../containers/NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { getPartner, getPartnerGuid, hasAuthourity } from '../../../../../lib/access.es6';
import { DisplayHcpClaims } from './DisplayHcpClaims';
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { CircularProgress } from '@mui/material';

const FilterHcpClaims = (props) => {
  const classes = useStyle();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  if (props.loading) {
    return <SkeletonWrapper loading={props.loading} />;
  }

  const currencyCode = getPartner().country.currency_code;

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
      props.getClaimsByStartDate(value);
    }
    if (name === "endDate") {
      setEndDate(value);
      props.getClaimsByEndDate(value);
    }
  };

  const handleFilterClaims = () => {
    props.getClaimsFiltered();
  };

  const handleClearFilter = () => {
    setStartDate('');
    setEndDate('');
    props.getClaimsFiltered({ start_date: '', end_date: '', page: 1 });
  };

  const handleClaimBulkApprove = () => {
    const payload = {
      start_date: startDate,
      end_date: endDate,
      partner: getPartnerGuid(),
    };
    props.handleBulkApproval(payload);
  };

  const handleBulkApproveSuccessfully = () => {
    props.resetBulkApproveSuccessAlert();
    handleClearFilter();
  };

  const handleBulkApproveError = () => {
    props.resetBulkApproveErrorAlert();
  };

  return (
    <>
      <section className={classes.claimTable}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} sm={12} className={classes.filterTitle}>
            <h2>Filter By:</h2>
          </Grid>
        </Grid>
        <ValidatorForm onSubmit={handleClaimBulkApprove}>
          <Grid container spacing={2} className={classes.filterWrapper}>
            <Grid item xs={12} md={4} sm={4}>
              <TextValidator
                id="startDate"
                label="Start Date"
                name='startDate'
                value={startDate}
                onChange={handleChange}
                fullWidth
                type='date'
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                required={props.hasBulkApprove}
                errorMessages={"start date is required"}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={4}>
              <TextValidator
                id="endDate"
                label="End Date"
                name='endDate'
                value={endDate}
                onChange={handleChange}
                fullWidth
                type='date'
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                required={props.hasBulkApprove}
                errorMessages={"end date is required"}
              />
            </Grid>
            {props.hasBulkApprove && (
              <Grid item xs={12} md={4} sm={4} className={classes.filterBtns}>
                <ButtonInc
                  hasPermision={hasAuthourity('BULK_APPROVE_CLAIMS')}
                  variant="contained"
                  type='submit'
                >
                  Bulk Approve
                </ButtonInc>
              </Grid>
            )}
          </Grid>
        </ValidatorForm>

        <Grid container spacing={2} style={{ padding: "20px 0" }}>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4}>
                <ButtonInc onClick={handleFilterClaims} variant="contained">
                  Filter Claims
                </ButtonInc>
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <ButtonInc onClick={handleClearFilter} variant="contained">
                  Clear Filter
                </ButtonInc>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <DisplayHcpClaims
          pagingData={props.pagingData}
          currencyCode={currencyCode}
          classes={classes}
          claims={props.claimsData || []}
          getClaimsFiltered={props.getClaimsFiltered}
        />

        {props.hasAlerts && (
          <>
            <AlertDialog
              custom
              show={props.showBulkApproveProgressAlert}
              size="sm"
              style={{ marginTop: '0', top: '30vh' }}
              confirmBtnText={'ok'}
              showCancel={false}
              showConfirm={false}
              cancelBtnText={'cancel'}
              showTitle={false}
              confirmBtnCssClass
            >
              <CircularProgress />
              <h2>submitting bulk approval request</h2>
            </AlertDialog>

            <AlertDialog
              success
              show={props.showBulkApproveSuccessAlert}
              size="sm"
              title={'submitted bulk approval request'}
              style={{ marginTop: '0', top: '30vh' }}
              onConfirm={handleBulkApproveSuccessfully}
              confirmBtnText={'ok'}
              showCancel={false}
              showConfirm={false}
              cancelBtnText={'cancel'}
              confirmBtnCssClass
            >
              <div>
                <ButtonInc
                  variant="contained"
                  onClick={handleBulkApproveSuccessfully}
                  style={{ background: 'green' }}
                >
                  Ok
                </ButtonInc>
              </div>
            </AlertDialog>

            <AlertDialog
              show={!!props.showBulkApproveErrorAlert}
              danger
              title={'Error submitting bulk approval request'}
              onConfirm={handleBulkApproveError}
              confirmBtnText={'Try again'}
              confirmBtnCssClass
              showCancel={false}
              style={{ marginTop: '0', top: '30vh' }}
            >
              {props.bulkApproveError ? props.bulkApproveError.message : ''}
            </AlertDialog>
          </>
        )}
      </section>
    </>
  );
};

export default FilterHcpClaims;
